import { px } from './px';

const GUTTER = 8;

export const spacing = (value: any) => (typeof value === 'number' ? px(GUTTER * value) : value);
